export default "__VITE_ASSET__CVoqBOQR__"